import { ColumnDef } from '@tanstack/react-table';
import { PencilIcon, Trash2 } from 'lucide-react';
import { FleetQueryData } from '@area-restrita/api-client/model/fleetQueryData';
import {
  useDeleteFleet,
  useUpdateFleet,
} from '@area-restrita/api-client/endpoints/fleets/fleets.gen';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';

import FleetForm from '../../components/FleetForm';
import { toast } from 'react-toastify';

export const columns: ColumnDef<FleetQueryData>[] = [
  { id: 'id', header: 'ID', accessorKey: 'id' },
  { id: 'prefix', header: 'Prefixo', accessorKey: 'prefix' },
  {
    header: 'Ações',
    meta: { className: 'text-right' },
    cell: function FleetActionsCell({ row }) {
      const { checkAuthorization } = useAuthSessionStore();

      const canUpdate = checkAuthorization(({ can }) =>
        can('update', 'fleets'),
      );
      const canDelete = checkAuthorization(({ can }) =>
        can('delete', 'fleets'),
      );

      const { mutateAsync: updateFleet } = useUpdateFleet();
      const { mutateAsync: deleteFleet } = useDeleteFleet();

      return (
        <div className="flex justify-end gap-3">
          <Dialog
            title="Editar Veículo"
            description="Preencha os campos abaixo para editar o veículo."
            trigger={
              <Button variant="outline" size="icon-sm" disabled={!canUpdate}>
                <PencilIcon className="h-4 w-4" />
              </Button>
            }
          >
            {({ handleClose }) => (
              <FleetForm
                defaultValues={row.original}
                onSubmit={(data) =>
                  updateFleet(
                    { id: row.original.id, data },
                    {
                      onSuccess: () =>
                        toast.success('Veículo atualizado com sucesso!'),
                      onError: () => toast.error('Erro ao atualizar veículo!'),
                      onSettled: () => handleClose(),
                    },
                  )
                }
              />
            )}
          </Dialog>

          <Dialog
            title="Excluir Veículo"
            trigger={
              <Button
                variant="destructive"
                size="icon-sm"
                disabled={!canDelete}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            }
          >
            <p>Tem certeza que deseja excluir este veículo?</p>
            <DialogFooter>
              <Button
                variant="destructive"
                size="sm"
                onClick={() =>
                  deleteFleet(
                    { id: row.original.id },
                    {
                      onSuccess: () =>
                        toast.success('Veículo excluído com sucesso!'),
                      onError: ({ message }) =>
                        toast.error(message || 'Erro ao excluir veículo!'),
                    },
                  )
                }
              >
                Excluir
              </Button>
            </DialogFooter>
          </Dialog>
        </div>
      );
    },
  },
];
